import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  maxWidth?: string;
  children: React.ReactNode;
}

export function Modal({ isOpen, onClose, title, description, maxWidth = "md", children }: ModalProps) {
  const maxWidthClass = maxWidth === "2xl" ? "sm:max-w-2xl" : "sm:max-w-md";
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className={`${maxWidthClass} p-0 gap-0 mt-10 max-h-[85vh] flex flex-col overflow-hidden rounded-xl border shadow-lg`}>
        {title && (
          <DialogHeader className="px-6 py-4 border-b bg-background sticky top-0 z-50">
            <DialogTitle>{title}</DialogTitle>
            {description && (
              <DialogDescription>{description}</DialogDescription>
            )}
          </DialogHeader>
        )}
        <div className="overflow-y-auto">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}